var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "hero bg-orange border-radius t-white p-3 p-md-6" },
    [
      _c("div", { staticClass: "hero-content" }, [
        _c("div", { staticClass: "active-users mb-12px py-4px px-12px" }, [
          _vm._v(_vm._s(_vm.activeUsers) + " active users today")
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "mb-2 t-white" }, [
          _vm._v(_vm._s(_vm.heading))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mb-2 t-white fs-18 font-weight-light" }, [
          _vm._v(_vm._s(_vm.content))
        ]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "btn btn-standard", attrs: { href: "/sign-up" } },
          [_vm._v("Become a member today")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ebbb9e5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebbb9e5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Hero.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7ebbb9e5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Hero.vue
// module chunks = 0 1